import { Link } from "react-router-dom";
import { useEffect } from "react";

const TermsPrivacy = () => {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="bg-soft container-small ">
      <div>
        <Link to="/" className="btn btn-link btn-lg d-md-block text-start ps-0">
          Regresar
        </Link>
      </div>
      <h1>TÉRMINOS Y CONDICIONES DE USO</h1>

      <h3 className="pt-3">Introducción y Aceptación</h3>
      <div className="pt-3">
        El presente documento establece los Términos y Condiciones de Uso (en
        adelante, “Términos”) que regulan el acceso y uso de la plataforma
        digital Fiestr (en adelante, el “Marketplace”), propiedad de Fiestr Tech
        S.A.P.I DE C.V. Al registrarse, acceder o utilizar el Marketplace, el
        Usuario acepta expresamente estos Términos.
      </div>

      <h3 className="pt-3">Definiciones</h3>
      <div className="pt-3">
        - Usuario: Persona física o moral que accede al Marketplace, ya sea como
        Cliente o Proveedor. <br />
        - Cliente: Usuario que utiliza el Marketplace para buscar, comparar y
        contratar servicios. <br />
        - Proveedor: Usuario que ofrece servicios o productos a través del
        Marketplace. <br />
        - Marketplace: Plataforma digital intermediaria que conecta a
        Proveedores y Clientes. <br />- Servicios: Servicios o productos
        ofrecidos por los Proveedores.
      </div>

      <h3 className="pt-3">Objeto del Contrato</h3>
      <div className="pt-3">
        El Marketplace actúa como intermediario tecnológico que facilita la
        comunicación y contratación entre Proveedores y Clientes. La empresa no
        es organizadora de eventos, ni prestadora directa de los servicios
        ofrecidos por los Proveedores.
      </div>

      <h3 className="pt-3">Registro y Cuentas</h3>
      <div className="pt-3">
        El Usuario deberá registrarse para acceder a ciertas funcionalidades. Se
        compromete a proporcionar información veraz, completa y actualizada. El
        Marketplace podrá suspender o cancelar cuentas en caso de
        incumplimiento.
      </div>

      <h3 className="pt-3">Publicación de Servicios</h3>
      <div className="pt-3">
        Los Proveedores son responsables exclusivos de la veracidad, calidad,
        legalidad y actualización de la información, imágenes y precios
        publicados. El Marketplace no garantiza la disponibilidad, calidad ni
        cumplimiento de los Servicios ofrecidos.
      </div>

      <h3 className="pt-3">Contratación entre Usuarios</h3>
      <div className="pt-3">
        La relación contractual se establece directamente entre Cliente y
        Proveedor. El Marketplace podrá ofrecer herramientas de pago o reservas,
        pero no asume responsabilidad sobre cancelaciones, devoluciones o
        incumplimientos. Las comisiones, en su caso, serán notificadas al
        Proveedor.
      </div>

      <h3 className="pt-3"> Limitación de Responsabilidad</h3>
      <div className="pt-3">
        El Marketplace no asume responsabilidad por daños, pérdidas,
        incumplimientos o controversias derivadas de la relación entre Cliente y
        Proveedor. El uso de la plataforma es bajo el riesgo y responsabilidad
        exclusiva de los Usuarios.
      </div>

      <h3 className="pt-3">Derechos de Propiedad Intelectual</h3>
      <div className="pt-3">
        El Marketplace y sus contenidos (marca, logotipos, software, diseño,
        etc.) son propiedad exclusiva de la empresa. Los Proveedores mantienen
        derechos sobre sus contenidos, pero al publicarlos otorgan licencia al
        Marketplace para mostrarlos con fines promocionales.
      </div>

      <h3 className="pt-3">Conducta Prohibida</h3>
      <div className="pt-3">
        Se prohíbe a los Usuarios: publicar información falsa, utilizar la
        plataforma para fines ilegales o fraudulentos, enviar spam, virus o
        contenido malicioso.
      </div>

      <h3 className="pt-3">Suspensión o Terminación</h3>
      <div className="pt-3">
        El Marketplace podrá suspender o dar por terminada la cuenta de
        cualquier Usuario que incumpla estos Términos, sin necesidad de previo
        aviso.
      </div>

      <h3 className="pt-3">Modificaciones</h3>
      <div className="pt-3">
        El Marketplace se reserva el derecho de modificar estos Términos en
        cualquier momento. Las modificaciones serán publicadas y entrarán en
        vigor al momento de su publicación.
      </div>

      <h3 className="pt-3"> Jurisdicción y Legislación Aplicable</h3>
      <div className="pt-3">
        Estos Términos se rigen por las leyes de los Estados Unidos Mexicanos.
        Para la interpretación y cumplimiento, las partes se someten a los
        tribunales competentes de Aguascalientes, México.
      </div>

      <h1>POLÍTICA DE PRIVACIDAD</h1>
      <h3 className="pt-3">Datos Recopilados</h3>
      <div className="pt-3">
       El Marketplace podrá recopilar datos personales (nombre, correo, teléfono), de facturación (RFC, razón social), y técnicos (IP, cookies, historial de navegación).
      </div>

      <h3 className="pt-3">Finalidad del Tratamiento</h3>
      <div className="pt-3">
        Los datos se utilizarán para: gestión de cuentas, comunicación entre usuarios, seguridad, prevención de fraudes y marketing (previo consentimiento).
      </div>

      <h3 className="pt-3">Base Legal del Tratamiento</h3>
      <div className="pt-3">
        El tratamiento se realiza con base en el consentimiento del Usuario y la necesidad de ejecutar la relación contractual.
      </div>

      <h3 className="pt-3">Compartición de Datos</h3>
      <div className="pt-3">
       Los datos podrán compartirse con Proveedores de servicios, autoridades competentes y pasarelas de pago.
      </div>

      <h3 className="pt-3">Derechos ARCO</h3>
      <div className="pt-3">
        El Usuario podrá ejercer sus derechos de Acceso, Rectificación, Cancelación y Oposición (ARCO) enviando solicitud al correo hola@fiestr.com
      </div>

      <h3 className="pt-3">Medidas de Seguridad</h3>
      <div className="pt-3">
        El Marketplace implementa medidas técnicas y organizativas para proteger los datos contra acceso no autorizado o divulgación indebida.
      </div>

      <h3 className="pt-3">Cookies y Tecnologías Similares</h3>
      <div className="pt-3">
       El Marketplace utiliza cookies para mejorar la experiencia del Usuario. El Usuario puede deshabilitarlas en su navegador.
      </div>

      <h3 className="pt-3">Transferencia Internacional de Datos</h3>
      <div className="pt-3">
        En caso de transferirse datos a servidores fuera de México, se garantizará un nivel adecuado de protección.

      </div>

      <h3 className="pt-3">Contacto</h3>
      <div className="pt-3">
        Para dudas o solicitudes de privacidad, contactar a: hola@fiestr.com
      </div>

    </section>
  );
};

export default TermsPrivacy;
// useNavigate hook from react-router-dom to go back to the last page in history.
